import { IncidentHistoryController } from '../controller/IncidentHistoryController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class IncidentHistoryWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IncidentHistoryController,
    });
  }
}
